module.exports = __webpack_public_path__ + "pc/img/ico-work.100c0f0a.svg";